module.exports = __webpack_public_path__ + "static/img/contactUsNew.8b1f511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contactUsNew.png
// module id = d6k+
// module chunks = 0